/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { DocumentDraftsControllerDownloadQueryResponse, DocumentDraftsControllerDownloadPathParams, DocumentDraftsControllerDownloadQueryParams, DocumentDraftsControllerDownload400, DocumentDraftsControllerDownload401, DocumentDraftsControllerDownload403, DocumentDraftsControllerDownload404 } from "../../models/documentDraftsController/DocumentDraftsControllerDownload";

function getDocumentDraftsControllerDownloadUrl(threadId: DocumentDraftsControllerDownloadPathParams["threadId"], version: DocumentDraftsControllerDownloadPathParams["version"]) {
  const res = { method: 'GET', url: `/api/v1/document-drafts/${threadId}/versions/${version}/download` as const }  
  return res
}

/**
 * {@link /api/v1/document-drafts/:threadId/versions/:version/download}
 */
export async function documentDraftsControllerDownload(threadId: DocumentDraftsControllerDownloadPathParams["threadId"], version: DocumentDraftsControllerDownloadPathParams["version"], params: DocumentDraftsControllerDownloadQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<DocumentDraftsControllerDownloadQueryResponse, ResponseErrorConfig<DocumentDraftsControllerDownload400 | DocumentDraftsControllerDownload401 | DocumentDraftsControllerDownload403 | DocumentDraftsControllerDownload404>, unknown>({ method : "GET", url : getDocumentDraftsControllerDownloadUrl(threadId, version).url.toString(), params, ... requestConfig })  
  return res.data
}